import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

// Masked line-by-line reveal
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-line">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1, ease: [0.76, 0, 0.24, 1], delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll reveal for a whole block
export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease, delay }}
  >
    {children}
  </motion.div>
);

// Clipped image frame reveal
export const ClipImage = ({ src, alt, className = "", imgClassName = "" }) => (
  <div className={`overflow-hidden ${className}`}>
    <motion.img
      src={src}
      alt={alt}
      loading="lazy"
      className={`w-full h-full object-cover ${imgClassName}`}
      initial={{ clipPath: "inset(14% 14% 14% 14%)", scale: 1.18 }}
      whileInView={{ clipPath: "inset(0% 0% 0% 0%)", scale: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.2, ease }}
    />
  </div>
);
